import { Box, Stack, Typography } from "fashion/fabrics";
import CodexLogo from "nodes/codex/CodexLogo";

const LOGO_SIZE = 100;

const CodexDisclaimer = () => (
  <Stack alignItems="center" gap={1}>
    <Box width={LOGO_SIZE} height={LOGO_SIZE}>
      <CodexLogo />
    </Box>
    <Typography variant="body2" color="text.secondary">
      © All rights reserved.
    </Typography>
    <Typography variant="body2" color="text.disabled">
      Libramium
    </Typography>
  </Stack>
);

export default CodexDisclaimer;
